import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
const ForRentTransactionSummary = (props) => {
    const listingText = `Last listed on ${props.rentalDate} at ${props.rentalPrice}`;
    if (!props.rentalDate && !props.rentalPrice) {
        return null;
    }
    return (
        <Typography
            sx={props.sx}
            title={listingText}
        >
            {listingText}
        </Typography>
    )
};

ForRentTransactionSummary.propTypes = {
    rentalDate: PropTypes.string,
    rentalPrice: PropTypes.string,
    sx: PropTypes.object,
};
export default ForRentTransactionSummary;